var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline"},[(! _vm.count && ! _vm.error)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}):(_vm.error)?_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"title":"Problema de conexão"}}):_c('span',[_vm._v(_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }